export default __webpack_public_path__ + "static/media/olorundare.0c767c2f.png";